import styled, { css } from 'styled-components'
import { FaStar, FaRegThumbsUp } from 'react-icons/fa'

export const ProfileTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  color: #555;
`

export const Wrapper = styled.div``

export const CardWrapper = styled.div`
  width: 50%;
  margin-bottom: 8px;
  @media (max-width: 800px) {
    width: 100%;
  }
`

export const CardBox = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 16px;

  .iconCredit {
    width: 40px;
    display: flex;
    align-items: center;
  }
`

export const MainCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 72px;
  height: 72px;
  /* margin-right: 15px; */

  label {
    max-width: 40px;
    max-height: 40px;
    display: flex;
    align-items: center;
    margin-top: -18px;
  }

  img {
    width: 60px;
    height: 60px;
  }
`

export const CardInfo = styled.div`
  justify-self: left;
  font-size: 14px;
  margin-left: 4px;
  margin-right: 8px;
  max-width: 300px;

  p > p {
    color: #707070;
  }
  strong {
    font-weight: 600;
  }

  select.parcelas {
    padding: 6px 30px 6px 16px;
    margin-bottom: -10px;
  }
`

export const CardInfoTitle = styled.p`
  margin-bottom: 2px;
  color: black;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
`
export const CardInfoLine = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 4px;
  font-size: 12px;
`

export const Seller = styled.p`
  text-decoration: underline;
  margin-left: 5px;
  font-size: 13px;
`

export const Price = styled.p`
  font-weight: 600;
  font-size: 12px;
  @media (max-width: 800px) {
    font-size: 10px !important;
  }
`
export const CardLinePrice = styled.div`
  display: flex;
`

export const AliquotaIPI = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 500;
  font-style: italic;
  font-size: 11px !important;
  text-overflow: hidden;
`

export const IPI = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 5px;
  font-weight: 500;
  font-style: italic;
  font-size: 10px !important;
  @media (max-width: 800px) {
    font-size: 8px !important;
  }
`
export const Quantidade = styled.p``
export const Alterar = styled.p`
  text-decoration: underline;
  margin-left: 10px;
  cursor: pointer;
`
export const CardIcon = styled.a`
  transition: all 400ms;
  max-width: 60px;
  font-size: 14px;
  max-height: 21px;
  position: absolute;
  right: 27px;

  & img {
    width: 18px;
    height: 21px;
    cursor: pointer;

    &:hover {
      filter: invert(22%) sepia(78%) saturate(2710%) hue-rotate(341deg)
        brightness(88%) contrast(96%);
    }
  }
`
export const ButtonAvaliacao = styled.button`
  font-family: inherit;
  background: transparent;
  color: #27ae60;
  font-weight: 600;
  border: none;
  font-size: 14px;
  margin-top: 6px;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  display: flex;
  align-items: center; // 🔥 isso alinha os ícones e texto
  gap: 2px; // espaço automático entre os elementos

  &:hover {
    text-decoration: none;
  }
`
export const TextAvaliacao = styled.span`
  font-family: inherit;
  background: transparent;
  color: #d22630;
  font-weight: 600;
  border: none;
  font-size: 14px;
  margin-top: 6px;
  padding: 0;
  display: flex;
  align-items: center; // 🔥 isso alinha os ícones e texto
  gap: 2px; // espaço automático entre os elementos
`
export const IconStar = styled(FaStar)`
  font-size: 14px;
`

export const IconThumb = styled(FaRegThumbsUp)`
  font-size: 14px;
`
